export default __webpack_public_path__ + "static/media/pig-red.eb00b225.svg";